<script lang="ts">
import { defineComponent } from 'vue'
import Sidebar from './Sidebar.vue'
import { appSidebarMobileCSS } from '@/models/'
import type { ISidebarProps } from './sidebar.interface'
import type { INavigationItem } from '@/models'
defineComponent({
  name: 'SidebarMobile',
})
</script>

<script setup lang="ts">
type TSidebarMobileProps = Omit<ISidebarProps, 'isCollapsed'> & {
  isOpen: boolean
}

const props = defineProps<TSidebarMobileProps>()

const emits = defineEmits<{
  (e: 'menuItemClicked', value: INavigationItem): any
  (e: 'close'): any
}>()

const handleClose = () => {
  emits('close')
}

const handleMenuItemClicked = (item: INavigationItem) => {
  emits('menuItemClicked', item)
  emits('close')
}
</script>

<template>
  <div v-if="isOpen" :class="appSidebarMobileCSS.wrapper" style="z-index: 9999" aria-label="Sidebar">
    <div class="fixed inset-0 bg-neutral bg-opacity-20" style="backdrop-filter: blur(2px)"></div>
    <div class="relative flex flex-col w-60 h-full z-20">
      <div class="absolute left-full inset-y-0 h-full flex mt-2 ml-2">
        <button
          type="button"
          class="fixed flex items-center justify-center h-8 w-8 rounded-full bg-sidebar content-sidebar"
          @click="handleClose"
        >
          <span class="sr-only">Close sidebar</span>
          <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            aria-hidden="true"
            class="size-6"
          >
            <path d="M6 18 18 6M6 6l12 12" stroke-linecap="round" stroke-line-join="round" />
          </svg>
        </button>
      </div>
      <Sidebar
        v-bind="props"
        :isCollapsed="false"
        @menuItemClicked="handleMenuItemClicked"
        @toggleSidebarCollapsed="handleClose"
      />
    </div>
  </div>
</template>
